import { makeStyles } from '@mui/styles'
import PropTypes from 'prop-types'
import { alpha } from '@mui/material'
import random from 'lodash.random'

const useStyles = () =>
  makeStyles((theme) => {
    const itemSize = theme.spacing(random(2, 24))

    return {
      '@keyframes animation': {
        '0%': {
          transform: 'translateY(0) rotate(0deg)',
          opacity: 1,
          borderRadius: '5%',
        },
        '65%': {
          opacity: 0.75,
        },
        '100%': {
          transform: 'translateY(-1000px) rotate(720deg)',
          opacity: 0,
          borderRadius: '50%',
        },
      },
      boxAppBackgroundAnimationItem: {
        position: 'absolute',
        display: 'block',
        listStyle: 'none',
        backgroundColor: `${alpha(theme.palette.common.white, 0.2)}`,
        animation: '$animation 25s linear infinite',
        bottom: '-50%',
        left: random(0, 100) + '%',
        width: itemSize,
        height: itemSize,
        animationDelay: random(0, 10) + 's',
        animationDuration: random(5, 25) + 's',
      },
    }
  })

const BoxAppBackgroundAnimationItem = () => <div className={useStyles()().boxAppBackgroundAnimationItem} />

BoxAppBackgroundAnimationItem.propTypes = {
  className: PropTypes.string,
}

export default BoxAppBackgroundAnimationItem
